//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowResizeHorizontal(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20.3101 12L16.11 7L13.5001 7L17.6901 12L13.5001 17L16.11 17L20.3101 12ZM10.5001 7L7.89008 7L3.69006 12L7.89008 17L10.5001 17L6.31006 12L10.5001 7Z" fill="currentColor" /></svg>;
}
export default IconArrowResizeHorizontal;